import { Injectable } from '@angular/core';
import { AppSettings, AsamcoAuthService, MessageBusService } from '@asamco/base';
import { bind } from '@asamco/utils';
import swal from 'sweetalert2';

import { AsamcoSignalrBase } from '../asamco-signalr-base';
import { UserLogoutData } from './userlogout-data';

@Injectable({
	providedIn: 'root',
	deps: [AsamcoAuthService, AppSettings, MessageBusService],
})
export class UserlogoutSignalrService extends AsamcoSignalrBase {
	/**
	 * Our hub name
	 */
	protected hubName = 'userSession';

	protected events = [{ methodName: 'Logout', newMethod: this.logout }];

	/**
	 *Creates an instance of UserlogoutSignalrService.
	 * @param {SignalR} signalr
	 * @param {AsamcoAuthService} auth
	 * @param {AppSettings} app
	 * @param {MessageBusService} msgbus
	 * @memberof UserlogoutSignalrService
	 */
	constructor(auth: AsamcoAuthService, app: AppSettings, private msgbus: MessageBusService) {
		super(auth, app);

		this.startService().subscribe({error: console.error});
	}

	/**
	 * Emit a forceLogout event
	 * @param logoutData Logout data received by the server
	 */
	@bind
	private logout(logoutData: UserLogoutData) {
		swal.fire({
			icon: 'warning',
			title: 'You have been logged out!',
			text: logoutData.reason,
		});
		location.reload();
	}
}
